<template>
    <b-card no-body>
        <div class="row p-2 align-items-end">
            <div class="col-md-3 mb-1">
                <label class="form-label">Ay</label>
                <v-select-list :options="months" v-model="requestData.Month" placeholder="Ay" ></v-select-list>
            </div>
            <div class="col-md-3 mb-1">
                <label class="form-label">Yıl</label>
                <v-select-list :options="years" v-model="requestData.Year" placeholder="Yıl" ></v-select-list>
            </div>
            <div class="col-md-3 mb-1">
                <label class="form-label">Plasiyer</label>
                <v-select-list :options="requesterUsers" label="FullName" v-model="requesterUserId" placeholder="Plasiyer" ></v-select-list>
            </div>
            <div class="col-md-3 mb-1">
                <label class="form-label">Sorumlu</label>
                <v-select-list :options="responsibleUsers" v-model="responsibleUserId" label="FullName" placeholder="Sorumlu" ></v-select-list>
            </div>
            
            <div class="col-md-3  mb-1">
                <label class="form-label">Durum</label>
                <select class="form-control" v-model="requestData.IsApproved">
                    <option v-for="o in approveStatuses" :value="o.Value" :key="o.Value">{{ o.Name }}</option>
                </select>        
            </div>
        </div>
        <div class="row mb-1">
            <div class="ml-2  mr-2">
            <v-executer :loading="filterLoading" :action="getReport">Filtrele</v-executer>
            </div>
            <div class="d-flex  justify-content-end">
                <v-executer :loading="filterLoading" :variant="success" :action="exportReport">Excel'e Aktar</v-executer>
            </div>
        </div>
        
     <table class="table">
        <thead>
            <tr>
                <th class="text-nowrap w-5">Cari Kod</th>
                <th class="text-nowrap w-15">Cari Adı</th>
                <th class="text-nowrap w-5">İstek Yapan</th>
                <th class="text-nowrap w-5">Sorumlu Kişi</th>
                <th class="text-nowrap w-5">Tutar</th>
                <th class="text-nowrap w-25">Açıklama</th>
                <th class="text-nowrap w-10">Ortalama Gün</th>
                <th class="text-nowrap w-10">Talep Tarihi</th>
                <th class="text-nowrap w-10">Onay Tarihi</th>
                <th class="text-nowrap w-10">Onay Durumu</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(report,index) in reportData">
                <td class="text-nowrap">{{ report.CustomerCode }}</td>
                <td class="text-nowrap">{{ report.CustomerName }}</td>
                <td class="text-nowrap">{{ report.RequesterUserName }}</td>
                <td class="text-nowrap">{{ report.ResponsibleUser }}</td>
                <td class="text-nowrap">{{ report.TotalAmount }}</td>
                <td class="text-nowrap">{{ report.Description }}</td>
                <td class="text-nowrap">{{ report.AvgDate }}</td>
                <td class="text-nowrap">{{ report.RequestTime }}</td>
                <td class="text-nowrap">{{ report.ApproveTime }}</td>
                <td class="text-nowrap">{{ report.IsApproved }}</td>
            </tr>
        </tbody>
     </table>
    </b-card>
      
</template>
<script>
import { NetsisApi } from '@/api/netsis'
import  {ReportApi} from '@/api/report'
import {UserApi} from '@/api/user'
import { BCard } from 'bootstrap-vue'

export default {
    components:{
        BCard
    },
    data(){
        return{
            filterLoading:false,
            months:[],
            reportData:[],
            responsibleUsers:[],
            requesterUsers:[],
            approveStatuses:[
                {Name: 'Tümü', Value: null},
                {Name: 'Onaylandı', Value: true},
                {Name: 'Onaylanmadı', Value: false}
            ],
            requestData:{
                Month:null,
                ResponsibleUserId: null,
                RequesterUserId: null,
                IsApproved:null,
                Year:null
            },
            years:[
                2023,
                2024,
                2025,
                2026
            ]
        }
    },
    mounted(){
        this.getMonths()
        this.getRequesterUsers()
        this.getResponsibleUsers()
    },
    methods:{
        getResponsibleUsers(){
            UserApi.ResponsibleUserList().then(res => {
                this.responsibleUsers = res.data.Data
            }).then(err =>{
                console.log(err)
            })
        },
        getRequesterUsers(){
            UserApi.SalesmanList().then(res=> {
                this.requesterUsers = res.data.Data
            }).catch(err=>{
                console.log(err)
            })
        },
        getReport(){
            this.filterLoading = true
           
            ReportApi.ReportOfResponsibleUserApprovement(this.requestData).then(res => {
                this.filterLoading = false
                this.reportData = res.data.Data
            }).catch(err=>{
                this.filterLoading = false
            })
        },
        exportReport(){
            this.getReport()
            this.filterLoading = true
           
           ReportApi.ExportReportOfResponsibleUserApprovement(this.requestData).then(res => {
               this.filterLoading = false
               this.$result(res)
           }).catch(err=>{
               this.filterLoading = false
           })
        },
        getMonths(){
            for (let index = 1; index <= 12; index++) {
                this.months.push(index)
                
            }
        }

    },
    computed:{
        requesterUserId:{
            get:function(){
                return this.requesterUsers.find(r=>r.Id == this.requestData.RequesterUserId)
            },
            set:function(value){
                this.requestData.RequesterUserId = value?.Id || null
            }
        },
        responsibleUserId:{
            get:function(){
                return this.responsibleUsers.find(r=>r.Id == this.requestData.ResponsibleUserId)
            },
            set:function(value){
                this.requestData.ResponsibleUserId = value?.Id || null
            }
        },
        status:{
            get:function(){
                return this.approveStatuses.find(r=>r.Value == this.requestData.IsApproved)
            },
            set:function(value){
                this.requestData.IsApproved = value?.Value || null
            }
        },
    }


}


</script>